import {Modal, Spinner} from "react-bootstrap";
import Button from "react-bootstrap/esm/Button";
import React, {useEffect, useState} from "react";
import BetterCheckBox from "../../../../common/BetterCheckBox";
import Alert from "react-bootstrap/esm/Alert";
import axios from "axios";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";

const DeleteDecorrelateModal = ({show, setShow, selectedTransactions, successCallback}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loadingDeletables, setLoadingDeletables] = useState(false);
    const [deletables, setDeletables] = useState([]);
    const [acceptDeletion, setAcceptDeletion] = useState(false);
    const [loadingDecorrelate, setLoadingDecorrelate] = useState(false);

    useEffect(() => {
        if (show) {
            handleDeccorelateAndDeleteSelections("check");
        } else {
            setDeletables([]);
            setAcceptDeletion(false);
        }
    }, [show])

    const handleDeccorelateAndDeleteSelections = (callType = "check") => {
        if (callType === "attempt") setLoadingDecorrelate(true);
        if (callType === "check") {
            setLoadingDeletables(true);
            setDeletables([]);
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/banking-decorrelate-delete-selections`, {
            company: company.id,
            transactionIds: selectedTransactions,
            callType: callType,
        }).then((res) => {
            if (res.data.status === "200") {
                if (callType === "attempt") {
                    setShow(false);
                    toast.success("Επιτυχής ενέργεια.");
                    if (successCallback) successCallback();
                } else if (callType === "check") {
                    setDeletables(res.data.data);
                }
            } else {
                toast.error(res.data.message);
            }
            if (callType === "attempt") setLoadingDecorrelate(false);
            if (callType === "check") setLoadingDeletables(false);
        }).catch((err) => {
            if (callType === "attempt") setLoadingDecorrelate(false);
            if (callType === "check") setLoadingDeletables(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal42PercentWidth"}>
            <Modal.Header closeButton>
                <Modal.Title>Αποσυσχέτιση & Διαγραφή επιλεγμένων</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loadingDeletables ? (
                    <div style={{textAlign: "center"}}>Παρακαλώ περιμένετε...</div>
                ) : (
                    <div>
                        {deletables.length === 0 ? (
                            <span>Δεν βρέθηκαν εγγραφές προς αποσυσχέτιση και διαγραφή.</span>
                        ) : (
                            <React.Fragment>
                                <Alert variant={"danger"}>
                                    <strong>Προσοχή:</strong> Κατά την διαγραφή εμπορικών εγγραφών θα διαγραφούν και οι αντίστοιχες γεφυρωμένες λογιστικές εγγραφές.
                                    Θα διαγραφούν μόνο οι εγγραφές που στον πίνακα αναγράφονται ως διαγράψιμες.
                                </Alert>
                                <table className={"simpleClassicTable"}>
                                    <colgroup>
                                        <col span={1} style={{width: "40%"}}></col>
                                        <col span={1} style={{width: "20%"}}></col>
                                        <col span={1} style={{width: "40%"}}></col>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th>Εγγραφή</th>
                                        <th>Διαγράψιμη</th>
                                        <th>Πληροφορίες</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {deletables.map((row, idx) => (
                                        <tr key={`deletables-${idx}`} style={{backgroundColor: row.deletable === false ? "#f79292" : ""}}>
                                            <td>{row["label"]}</td>
                                            <td>{row["deletable"] === true ? "Ναι" : "Όχι"}</td>
                                            <td>{row["deletableMessage"]}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </React.Fragment>
                        )}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <BetterCheckBox
                    name={"acceptDeletion"}
                    className={"mt-2"}
                    text={<span>Αποδέχομαι την βαρύτητα της ενέργειας <span style={{color: "red"}}>(*)</span></span>}
                    checked={acceptDeletion}
                    disabled={loadingDecorrelate || loadingDeletables || !deletables.some((el) => el.deletable)}
                    required={true}
                    onChange={(e) => setAcceptDeletion(e.target.checked)}
                />
                <Button disabled={loadingDecorrelate || loadingDeletables || !deletables.some((el) => el.deletable) || !acceptDeletion} variant="primary" onClick={() => handleDeccorelateAndDeleteSelections("attempt")}>
                    Αποσυσχέτιση & Διαγραφή {loadingDecorrelate && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteDecorrelateModal;
